import { oliveBackgroundTokens, oliveBorderTokens } from '@ds/tokens'

const tokens = {
  backgroundColor: oliveBackgroundTokens.bgColorDefault,
  borderColor: '#cccccc',
  borderRadius: oliveBorderTokens.borderRadiusDefault,
} as const

export default tokens
